// 财务发票（销售合同下的业务单据页面配置）
// 【P218】按需求重建为 13 项字段：
//   01 发票标题(自动生成) 02 客户(自动关联) 03 销售合同(自动关联) 04 开发公司=收款公司(选择)
//   05 所属合同=本销售合同下的财务合同(选择) 06 发票类型(增值祱普通/增值祱专用)
//   07 抬头 08 税号 09 地址 10 电话 11 银行账号 12 备注(富文本) 13 审批(同支付单)
import {
  getContractInvoiceListData,
  saveContractInvoiceData,
  saveContractInvoiceEditData,
  saveContractInvoiceDeleteData
} from "../../api/api.js";

/* 开发公司 / 收款公司：与支付单 company_sn 同一套枚举（PC CRMPaymentOrders 对齐） */
const COMPANY_OPTIONS = [
  { label: "上海泰耀会展服务有限公司", value: 1 },
  { label: "上海燚耀企业管理有限责任公司", value: 2 },
  { label: "上海枞耀企业管理有限责任公司", value: 3 },
  { label: "上海恪豪企业管理有限责任公司", value: 4 },
  { label: "上海晏耀企业管理有限责任公司", value: 5 },
  { label: "北京泰耀会展服务有限公司", value: 6 },
  { label: "深圳枞耀企业管理有限责任公司", value: 7 },
  { label: "天津枞耀企业管理有限责任公司", value: 8 }
];

export default {
  key: "invoice",
  title: "财务发票",
  short: "财务发票",
  icon: "bill-o",
  listFn: getContractInvoiceListData,
  saveFn: saveContractInvoiceData,
  editFn: saveContractInvoiceEditData,
  deleteFn: saveContractInvoiceDeleteData,
  // 卡片标题：发票标题 · 金额
  titleFields: ["title", "amount"],

  /* 【P218】财务合同下拉：只列本销售合同产生的财务合同（category：1预定/2订餐/3茶歇/4充值/5其他） */
  financeContractOptionsFn: "invoice_finance_contracts",

  fields: [
    /* ===== 01 发票标题：【P226 优化】改为自动生成，**表单不再显示** =====
       原为 readonly 文本框展示（P219 改由前端 buildInvoiceTitle 生成）。
       用户要求「发票标题需要自动生成不需要显示」⇒ type 改 hidden，
       仍由 genByType + 发票类型 onChange 正常写入 addForm.title 并提交，
       只是页面上不再占一行。 */
    { prop: "title", label: "发票标题", type: "hidden", group: "发票信息",
      autoFill: true, genByType: true },

    /* ===== 02 客户：【P226 修复】原先只显示 SN =====
       根因：options 为空 + 未设 nameKey 兜底，selectText() 找不到 label 就直接吐 value(sn)。
       修法：nameKey 保持 customer_name（列表/详情回读用），
             autoFill 时由 mixin 用 orderDetail.customer_name 预填 label；
             并补 options 来源（销售合同详情弹层里就是本合同客户，一个选项即可）。 */
    { prop: "customer_sn", label: "客户", type: "select", group: "发票信息",
      options: [], nameKey: "customer_name", readonly: true, autoFill: true,
      placeholder: "自动关联销售合同的客户" },

    /* ===== 03 销售合同：自动关联（就是当前所在合同），只读隐藏 ===== */
    { prop: "order_sn", label: "销售合同", type: "hidden", group: "发票信息", autoFill: true },

    /* ===== 04 开发公司：选择（收款公司）===== */
    { prop: "company_sn", label: "开发公司", type: "select", required: true, group: "发票信息",
      placeholder: "请选择开发公司（收款公司）", options: COMPANY_OPTIONS },

    /* ===== 05 所属合同：【P226 修复】原先显示 SN =====
       根因：`optionsFn: "invoice_finance_contracts"` 这个字典键**后端根本没有**，
             selectText() 取不到 label ⇒ 直接显示 value(sn)。
       修法：后端 P226 已在 orderRoomFormOptions 补发该键（已按 owner_id 收敛）；
             前端补 nameKey 兜底，避免后端返回空时又显示 sn。 */
    { prop: "contracts_sn", label: "所属合同", type: "select", required: true, group: "发票信息",
      optionsFn: "invoice_finance_contracts", nameKey: "contracts_name",
      placeholder: "请选择所属财务合同" },

    /* ===== 06 发票类型：增值祱普通 / 增值祱专用 ===== */
    { prop: "type", label: "发票类型", type: "select", required: true, group: "发票信息",
      placeholder: "请选择发票类型",
      /* 【P219】onChange：选类型时 JS 即时生成发票标题 */
      onChange: "buildInvoiceTitle",
      options: [
        { label: "增值祱普通", value: 1 },
        { label: "增值祱专用", value: 2 }
      ] },

    /* ===== 07~11 购买方信息 ===== */
    { prop: "buyer_name", label: "抬头", type: "text", group: "购买方信息",
      placeholder: "请输入发票抬头" },
    { prop: "buyer_tax_no", label: "税号", type: "text", group: "购买方信息",
      placeholder: "请输入纳税人识别号" },
    { prop: "buyer_address", label: "地址", type: "text", group: "购买方信息",
      placeholder: "请输入地址" },
    { prop: "buyer_phone", label: "电话", type: "text", group: "购买方信息",
      placeholder: "请输入电话" },
    { prop: "buyer_bank_account", label: "银行账号", type: "text", group: "购买方信息",
      placeholder: "请输入银行账号" },

    /* ===== 12 金额（发票必填，保留在发票信息组）===== */
    { prop: "amount", label: "金额", type: "number", required: true, group: "发票信息",
      placeholder: "请输入金额" },

    /* ===== 13 备注：富文本（由 contractDetail.vue 的 RichEditor 渲染，prop==='remark' 走富文本）===== */
    { prop: "remark", label: "备注", type: "textarea", group: "发票信息",
      placeholder: "选填" },

    /* ===== 14 审批：与支付单一致（审批人 + 提示条 + 存草稿/提交审批双动作）===== */
    {
      prop: "approval_notice", label: "", type: "notice", tone: "warn", group: "审批",
      text: "该发票提交后进入「待财务审核」，审批通过后才生效。",
      showIf: function (form) { return true; }
    },
    {
      prop: "approval_user_id", label: "审批人", type: "select", required: true, group: "审批",
      /* 【P219】★ 原来 options 是空数组、也没有任何加载逻辑 ⇒ 审批人下拉永远空白
         —— 这是「审批人是空的」的第二个原因。现由 mixin 的 loadInvoiceFinanceStaff 灌数据。 */
      placeholder: "财务部门人员 · 默认陈凯蕾"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/Invoices.js